import { render, staticRenderFns } from "./JobProfileEnhanced.vue?vue&type=template&id=668b7d88&"
import script from "./JobProfileEnhanced.vue?vue&type=script&lang=js&"
export * from "./JobProfileEnhanced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports